export default __webpack_public_path__ + "afffda566a2b35b3dd11823d3805f6a0.png";